class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends MenuDrawer {
  constructor() {
    super();

    this.addEventListener('click', () => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);
          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 500);
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);


      
// CD COde
document.querySelectorAll('[data-switcher]').forEach(btn => {
  btn.addEventListener('click', function () {
    
    // remove current class
    document.querySelectorAll('[data-switcher]').forEach(el => {
      el.classList.remove('_current');
    });

    // add current class
    this.classList.add('_current');

    let type = this.getAttribute('data-switcher').toLowerCase();

    // hide all spans
    document.querySelectorAll('.product-variant-picker__item span').forEach(span => {
      span.style.display = 'none';
    });

    // show selected type
    document.querySelectorAll('.product-variant-picker__item span.' + type).forEach(span => {
      span.style.display = 'inline-block';
    });

    var custom_current = this.getAttribute('data-switcher'),
        split_value = this.closest(".product-form__input").querySelector('.product-variant-picker__item input:checked').value.split(' - '),
        selected_value = '';
    split_value.forEach(function(e, i){
      if(e.includes(custom_current)){
        selected_value = e;
      }
    })
    document.querySelector(".custom_var [data-selected-value]").innerHTML = selected_value;

  });
});

document.querySelectorAll('input[name="custom-var-option"]').forEach(input => {
  input.addEventListener('change', function () {
    var custom_current = this.closest(".product-form__input").querySelector('._current').getAttribute('data-switcher'),
        split_value = this.value.split(' - '),
        selected_value = '';
    split_value.forEach(function(e, i){
      if(e.includes(custom_current)){
        selected_value = e;
      }
    })
    document.querySelector(".custom_var [data-selected-value]").innerHTML = selected_value;
    document.querySelector("variant-selects .product-form__input input[value='"+ this.value +"']").click();
  });
});


document.addEventListener("click", function (e) {

  if (e.target.matches("[data-show-more]")) {

    const wrapper = e.target.closest(".swatches");

    wrapper.querySelectorAll(".hidden-swatch").forEach(el => {
      el.classList.remove("hidden-swatch");
    });

    e.target.style.display = "none";
  }

});

    });
  }
}
customElements.define('quick-view', QuickView);
